import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Label } from "@/components/ui/label";
import type { CustomerCategory } from "@/hooks/useCustomerCategories";

interface Props {
  categories: CustomerCategory[];
  selected: string; // "global" or category id
  onSelect: (value: string) => void;
}

export default function CategoryRuleSelector({ categories, selected, onSelect }: Props) {
  return (
    <div className="space-y-1">
      <Label className="text-xs">Regelvy per kategori</Label>
      <Select value={selected} onValueChange={onSelect}>
        <SelectTrigger className="h-8 text-xs w-[220px]">
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="global">🌐 Standardregler (alla)</SelectItem>
          {categories.filter(c => !c.is_default).map((c) => (
            <SelectItem key={c.id} value={c.id}>{c.name}</SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
